<script setup lang="ts">
import { WifiOff } from 'lucide-vue-next';

import { useOnlineStatus } from '~/composables/use-online-status';

const { isOnline } = useOnlineStatus();
</script>

<template>
  <Transition
    enter-active-class="transition-transform duration-200 ease-out"
    enter-from-class="-translate-y-full"
    enter-to-class="translate-y-0"
    leave-active-class="transition-transform duration-150 ease-in"
    leave-from-class="translate-y-0"
    leave-to-class="-translate-y-full"
  >
    <div
      v-if="!isOnline"
      role="status"
      aria-live="polite"
      class="fixed inset-x-0 top-0 z-[var(--z-toast)]
             bg-warning text-white text-sm font-medium
             px-4 py-2 flex items-center justify-center gap-2
             pt-[max(env(safe-area-inset-top),0.5rem)] shadow-md"
    >
      <WifiOff class="size-4" />
      <span>Çevrimdışısın — bazı işlemler tamamlanmayabilir.</span>
    </div>
  </Transition>
</template>
